<template>
  <div class="production_wrap">
    <div class="production_img">
      <div class="img_tit">{{ $t('productionBrain.title') }}</div>
    </div>
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="develop_wrap">
          <div class="develop_left">
            <h1>{{ $t('productionBrain.whatIs') }}</h1>
            <p class="p2">
              {{ $t('productionBrain.description') }}
              {{ $t('productionBrain.explanation') }}
            </p>
            <ol class="outer-list">
              <li>{{ $t('productionBrain.connotation.title') }}
                <ol class="inner-list">
                  <li><strong>{{ $t('productionBrain.connotation.lifecycle.title') }}</strong>：{{ $t('productionBrain.connotation.lifecycle.desc') }}</li>
                  <li><strong>{{ $t('productionBrain.connotation.emissions.title') }}</strong>：{{ $t('productionBrain.connotation.emissions.desc') }}</li>
                </ol>
              </li>
              <li>{{ $t('productionBrain.extension.title') }}
                <ol class="inner-list">
                  <li><strong>{{ $t('productionBrain.extension.quantitative.title') }}</strong>：{{ $t('productionBrain.extension.quantitative.desc') }}</li>
                  <li><strong>{{ $t('productionBrain.extension.environmental.title') }}</strong>：{{ $t('productionBrain.extension.environmental.desc') }}</li>
                </ol>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <p class="p1">{{ $t('productionBrain.flowchart') }}</p>
    <div class="production_card">
      <ProCard :procardList="procardList" />
    </div>
    <p class="p1">{{ $t('productionBrain.database') }}</p>
    <div class="production_card">
      <ProCard3 :procardList="procardList" />
    </div>
    <p class="p1">{{ $t('productionBrain.report') }}</p>
    <div class="advantage_out_wrap">
      <AdvantageCard />
    </div>
    <!-- <p class="p1">{{ $t('productionBrain.allocation') }}</p> -->
    <div class="production_card" style="margin-top: 50px;">
      <ProCard4 :procardList="procardList" />
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import ProCard from './ProCard.vue'
import ProCard3 from './ProCard3.vue'
import ProCard4 from './ProCard4.vue'
import AdvantageCard from './AdvantageCard.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
export default {
  data() {
    return {
      procardList: [
        {
          tit: '产业链数据中心',
        },
        {
          tit: '产业链监测',
        },
        {
          tit: '产业评价',
        },
        {
          tit: '产业地图',
        },
        {
          tit: '智能招商系统及服务',
        },
      ],
    }
  },
  components: {
    ProCard,
    ProCard3,
    ProCard4,
    AdvantageCard,
    CallMe,
    MobileCallme,
  },
}
</script>

<style lang="scss" scoped>
.production_wrap {
  width: 100%;
  .production_img {
    width: 100%;
    height: 650px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url('../../assets/img/bg/bg-2.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        color: #fff;
        background: orange;
      }
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }
  .production_title_wrap {
    width: 100%;
    margin-top: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }
    .production_inner {
      display: flex;
      justify-content: center;
      .inner_center {
        width: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 50px;
        @media screen and (max-width: 768px) {
          flex: 2.2;
        }
        .production_title {
          font-size: 40px;
          font-weight: bold;
          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }
        .production_desc {
          font-size: 16px;
          color: #787878;
          margin-top: 10px;
          @media screen and (max-width: 768px) {
            margin-top: 10px;
            font-size: 14px;
          }
        }
      }
    }
  }
  .p1 {
    text-align: center;
    color: #3b3b3b;
    font-weight: bold;
    font-size: 20px;
    line-height: 100px;
    @media screen and (max-width: 768px) {
      font-size: 0.9rem;
      padding: 15px 0;
    }
  }
  .production_card {
    display: flex;
    justify-content: center;
  }
  .advantage_out_wrap {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .carousel_pro {
    width: 60%;
    margin: 60px auto;
    .carousel_pro_item {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .product_shows_wrap {
    width: 100%;
    background: url('../../assets/img/witness-bgc369221.png') 0 0 no-repeat;
    background-size: cover;
    padding: 10px 0 50px 0;
    margin-top: 100px;
    box-sizing: border-box;
    .with_center {
      display: flex;
      justify-content: center;
      .bottom_img_wrap {
        width: 80%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        @media screen and (max-width: 768px) {
          width: 100%;
        }
        .bottom_img_item {
          width: 30%;
          display: flex;
          flex-wrap: wrap;
          margin-top: 20px;
          margin: 20px;
          h2 {
            color: #3b3b3b;
          }
          @media screen and (max-width: 768px) {
            width: 45%;
          }
          .bottom_img {
            width: 100%;
            position: relative;
            img {
              width: 100%;
            }

            .img_desc {
              position: absolute;
              bottom: 20px;
              width: 100%;
              text-align: center;
              color: #fff;
              font-size: 18px;
              @media screen and (max-width: 768px) {
                font-weight: bold;
                bottom: 8px;
                font-size: 13px;
              }
            }
          }
        }
      }
    }
  }
  .develop_wrap {
    width: 70%;
    margin: 0 auto;
    display: flex;
    @media screen and (max-width: 768px) {
      width: 90%;
      flex-direction: column;
      margin-bottom: 30px;
    }
    .develop_left {
      background-color: #f2f7ff;
      border-radius: 20px;
      padding: 20px;
      h1 {
        font-size: 26px;
        @media screen and (max-width: 768px) {
          font-size: 0.95rem;  
        }
      }
      .p2 {
        margin-top: 30px;
        font-size: 20px;
        color: #5b6e74;
        @media screen and (max-width: 768px) {
          font-size: 13px;
        }
      }
    }
  }
  /* 外层列表 */
  .outer-list {
    padding-left: 20px;
    font-size: 17px;
    list-style-type: none;
    @media screen and (max-width: 768px) {
        font-size: 0.75rem;  
      }
  }

  /* 内层列表 */
  .inner-list {
    margin-left: 20px;
    padding-left: 20px;
    font-size: 16px;
    list-style-type: none;
    line-height: 2rem;
    @media screen and (max-width: 768px) {
        font-size: 0.75rem;  
      }
  }
  .outer-list > li::before {
    content: "• "; /* 添加自定义符号 */
    color: #000; /* 设置符号颜色 */
    margin-right: 10px; /* 控制符号和文字之间的间距 */
  }
  .inner-list > li::before {
    content: "\25CB"; /* 添加自定义符号 */
    color: #000; /* 设置符号颜色 */
    margin-right: 10px; /* 控制符号和文字之间的间距 */
  }
}
</style>